// Factories
import { BaseServiceFactory } from "../../base/factories/BaseServiceFactory";
/** Implementation of the service provider factory for the Uno Web app */
export class WebServiceFactory extends BaseServiceFactory {
    getOneShellServiceProvider(requestClient, requestPrioritizer, configProvider) {
        return () => this.loader.load(this.getServiceBundleKey("oneshell"), () => import(/* webpackChunkName: "uno-oneshellservice" */ "@ms/uno-services/lib/local/services/oneshell/OneShellService"), (bundle) => new bundle.OneShellService(requestClient, configProvider));
    }
}
